<template>
  <footer id="footer">
    <div class="container-fluid">

      <div id="footer-links" class="row mb-4">
        <div class="col-lg-7">
          <form  class="d-flex flex-column flex-md-row align-items-center gap-3" autocomplete="off">
            <input v-model="data_.userAddress" type="text" class="form-control" id="floatingInputEmail" placeholder="Correo electrónico">
            <button :onclick="() =>submit()" type="button" class="btn btn-sm lh-1 btn-secondary">Contacta conmigo</button>
          </form>
          <div v-if="data_.message" :class="data_.isError? 'alert alert-danger mt-1' : 'alert alert-success mt-1'" role="alert">
            {{data_.message}}
          </div>
          <p class="mt-3" style="opacity:0.7; font-size: 0.7rem;">Al pulsar en el botón “Contacta conmigo”, consientes que los datos personales que nos facilitas sean tratados por AXACTOR ESPAÑA PLATFORM, S.A.U. como responsable del tratamiento, para contactarte y ofrecerte información sobre sus productos y servicios. Puedes ejercer los derechos establecidos en los arts. 15 a 22 del RGPD en las direcciones que encontrarás en la información adicional en nuestra <a :href="urlWp + '/politica-de-privacidad/'">Política de Privacidad.</a></p>
          <p class="form-text">Nuestra metodología incluye un trato cercano a medida de las necesidades de cada cliente.</p>
        </div>
        <div class="col-lg-4 col-xl-3 offset-lg-1">
          <ul class="list-unstyled">
            <li><a :href="urlWp + '/aviso-legal/'">Aviso legal</a></li>
            <li><a :href="urlWp + '/politica-de-privacidad/'">Política de privacidad</a></li>
            <li><a :href="urlWp + '/politica-de-cookies/' ">Política de cookies</a></li>
            <li><a :href="urlWp + '/condiciones-generales-de-uso/' ">Condiciones generales de uso</a></li>
          </ul>
        </div>
      </div>

      <div id="footer-copy" class="small">
        <div class="row align-items-lg-end">
          <div class="col-lg-7">
            <div class="socials">
              <a href="https://www.linkedin.com/company/trecupera/about/?viewAsMember=true"><i class="bi bi-linkedin"></i></a>
              <a href="https://www.facebook.com/profile.php?id=100093467178409"><i class="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/trecupera._/"><i class="bi bi-instagram"></i></a>
            </div>
            <p class="mb-0 mt-3 opacity-75">© 2023 TRecupera. All Rights Reserved.</p>
          </div>
          <div class="col-lg-4 col-xl-3 offset-lg-1">
            <address class="m-0">
              <p class="m-0">
                C/ Doctor Esquerdo 136, 4ª Plta.<br>
                28007 Madrid<br>
                <a @click="phoneCall" href="#">913246950</a>
                <br>
                <a :href="urlWp + '#stepper'" >Cómo funciona</a><br>
                <a @click="mailTo" href="#">info@trecupera.com</a>

              </p>
            </address>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">

import {useRouter} from "vue-router";
import {reactive} from "vue";
import axios from "axios";
import * as utils from "@/api/utilities";

export default {
  name: 'Footer',



  setup() {

    const data_ = reactive({
      companyEmail: "infotrecupera@axactor.com",
      companyPhone: "913246950",
      userAddress: '',
      message: '',
      isError: false
    });

    const router = useRouter();

    const goRoute_ = (type: string) => {
      const route = router.resolve({
        name: type,
        params: {},
      });
      window.open(route.href, "_blank");
    };

    const mailTo = () => {
      window.location.href = `mailto: ${data_.companyEmail}`;
    };

    const phoneCall = () => {
      window.location.href = `tel: ${data_.companyPhone}`;
    };


    const submit = async () => {

      const errorEmail = utils.form_reg_email(data_.userAddress);

      if (errorEmail !== "") {
        data_.message = "Email introducido no es correcto";
        data_.isError = true;
        return ;
      }

      data_.message = '';
      data_.isError = false


      const url = "https://trecupera-pre.com/wp-json/contact-form-7/v1/contact-forms/858/feedback";

      let response = null
      try {
        response = await axios.post(url,
            '------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="_wpcf7"\r\n\r\n858\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="_wpcf7_version"\r\n\r\n5.7.7\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="_wpcf7_locale"\r\n\r\nes_ES\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="_wpcf7_unit_tag"\r\n\r\nwpcf7-f858-o2\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="_wpcf7_container_post"\r\n\r\n0\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="_wpcf7_posted_data_hash"\r\n\r\n64b839dcbd32a21e1288d3a0e3c53a9e\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC\r\nContent-Disposition: form-data; name="email-collect"\r\n\r\n'+ data_.userAddress+'\r\n------WebKitFormBoundaryVAvvmjBvamgNAndC--\r\n',
            {
              headers: {
                'accept': 'application/json, */*;q=0.1',
                'content-type': 'multipart/form-data; boundary=----WebKitFormBoundaryVAvvmjBvamgNAndC'
              }
            }
        )
      } catch (e: any) {
        response = e.response || e.request;
      }

      if(response.status== 200) {
        data_.message = response.data.message;
        data_.isError = true

        if (response.data.status.includes('failed')){
          data_.isError = true
        } else {
          data_.isError = false
        }
      }else{

      }
    }


    return {
      goRoute_,
      mailTo,
      phoneCall,
      submit,
      data_,
      urlWp: process.env.VUE_APP_URL_WP
    };

  }
}

</script>
